<form [formGroup]="backgroundForm">

    <p *ngIf="isMobile" class="headline6Light"> 3/4 {{ 'registration.stepThree.titleMobile' | translate}}</p>

    <mat-card class="cardCenter2">
        <p class="headline5NoCenter">{{ 'registration.stepThree.background' | translate}}</p>
        <p class="subtitle3">{{ 'registration.stepThree.question1.question' | translate}}</p>
        <mat-radio-group aria-labelledby="radioGroupColumn" class="radioGroupColumn" formControlName="background"
            required>
            <mat-radio-button color="primary" class="example-radio-button" *ngFor="let background of backgrounds"
                [value]="background">
                {{background}}
            </mat-radio-button>
        </mat-radio-group>

        <mat-divider></mat-divider>

        <p class="subtitle3">{{ 'registration.stepThree.question2' | translate}}</p>
        <mat-radio-group aria-labelledby="radioGroupRow" class="radioGroupRowWithMargin" formControlName="days"
            required>
            <mat-radio-button color="primary" class="radioButtonHorizontal" *ngFor="let day of days" [value]="day">
                {{day}}
            </mat-radio-button>
        </mat-radio-group>

        <mat-divider></mat-divider>

        <p class="subtitle3">{{ 'registration.stepThree.question3' | translate}}</p>
        <mat-form-field appearance="fill" class="inputfullWidth">
            <mat-label>{{ 'registration.stepThree.genericAnswers.tellUs' | translate}}</mat-label>
            <textarea maxlength="250" id="trainingWeekInput" formControlName="trainingWeek" matInput></textarea>
            <mat-hint align="end">{{backgroundForm.value.trainingWeek?.length || 0}} / 250</mat-hint>
        </mat-form-field>

        <mat-divider></mat-divider>

        <p class="subtitle3">{{ 'registration.stepThree.question4' | translate}}</p>
        <mat-radio-group *ngIf="!isMobile" class="radioGroupRow" required formControlName="condition">
            <mat-radio-button *ngFor="let condition of conditions" color="primary" class="hideButton"
                [value]="condition">
                <label for="condition-button">
                    <div class="flexInLineCenter">
                        <button class="buttonSmall" *ngIf="!condition.selected" (click)="saveCondition(condition)"
                            mat-stroked-button>{{condition.name}}</button>
                        <button class="buttonSmall2" *ngIf="condition.selected" color="primary" (click)="saveCondition(condition)"
                            mat-raised-button>{{condition.name}}</button>
                    </div>
                </label>
            </mat-radio-button>
        </mat-radio-group>

        <mat-radio-group *ngIf="isMobile" class="flexColumn" required formControlName="condition">
            <mat-radio-button *ngFor="let condition of conditions" color="primary" class="hideButton"
                [value]="condition">
                <label for="condition-button">
                        <button class="primaryButton3" *ngIf="!condition.selected" (click)="saveCondition(condition)"
                            mat-stroked-button>{{condition.name}}</button>
                        <button class="primaryButton3" *ngIf="condition.selected" color="primary" (click)="saveCondition(condition)"
                            mat-raised-button>{{condition.name}}</button>
                </label>
            </mat-radio-button>
        </mat-radio-group>


        <br/>
        <mat-divider></mat-divider>

        <p class="subtitle3">{{ 'registration.stepThree.question5' | translate}}</p>
        <mat-radio-group aria-labelledby="radioGroupColumn" class="radioGroupColumn" 
            required>

            <mat-radio-button color="primary" value="yes" (click)="changeComplements(true)">{{'registration.stepThree.genericAnswers.yes' | translate}}</mat-radio-button>
                
            <mat-form-field *ngIf="showComplements" appearance="fill" class="inputfullWidth">
                    <mat-label>{{ 'registration.stepThree.workName' | translate}}</mat-label>
                    <textarea maxlength="250" id="complementInput" formControlName="complement" matInput required></textarea>
                    <mat-hint align="end">{{backgroundForm.value.complement?.length || 0}} / 250</mat-hint>
                </mat-form-field>
            <mat-radio-button color="primary" value="no" (click)="changeComplements(false)">{{'registration.stepThree.genericAnswers.no' | translate}}</mat-radio-button>
        </mat-radio-group>

        <mat-divider></mat-divider>

        <p class="subtitle3">{{ 'registration.stepThree.question6' | translate}}</p>
        <mat-form-field appearance="fill" class="inputfullWidth">
            <mat-label>{{ 'registration.stepThree.genericAnswers.tellUs' | translate}}</mat-label>
            <textarea maxlength="250" id="restAndFoodInput" formControlName="restAndFood" matInput required></textarea>
            <mat-hint align="end">{{backgroundForm.value.restAndFood?.length || 0}} / 250</mat-hint>
        </mat-form-field>

        <mat-divider></mat-divider>

        <p class="subtitle3">{{ 'registration.stepThree.question7' | translate}}</p>
        <mat-form-field appearance="fill" class="inputfullWidth">
            <mat-label>{{ 'registration.stepThree.genericAnswers.tellUs' | translate}}</mat-label>
            <textarea maxlength="50" id="shoesInput" formControlName="shoes" matInput required></textarea>
            <mat-hint align="end">{{backgroundForm.value.shoes?.length || 0}} / 50</mat-hint>
        </mat-form-field>

        <p class="subtitle3">{{ 'registration.stepThree.question8.title' | translate}}</p>
        <p class="body2"><mat-checkbox (click)="changeFromCheckbox('ruta')" color="primary" formControlName="ruta">{{ 'registration.stepThree.question8.ruta' | translate}}</mat-checkbox></p>
        <div *ngIf="backgroundForm.value.ruta">
            <app-achievements
                [mode]="'ruta'"
                (changeAchievementEvent)="changeAchievement($event)"
                (emptyAchievementEvent)="emptyAchievement($event)">
            </app-achievements>
        </div>

        <p class="body2"><mat-checkbox (click)="changeFromCheckbox('pista')" color="primary" formControlName="pista">{{ 'registration.stepThree.question8.pista' | translate}}</mat-checkbox></p>
        <div *ngIf="backgroundForm.value.pista">
            <app-achievements 
                [mode]="'pista'"
                (changeAchievementEvent)="changeAchievement($event)"
                (emptyAchievementEvent)="emptyAchievement($event)">
            </app-achievements>
        </div>

        <p class="body2"><mat-checkbox (click)="changeFromCheckbox('trail')" color="primary" formControlName="trail">{{ 'registration.stepThree.question8.trail' | translate}}</mat-checkbox></p>
        <div *ngIf="backgroundForm.value.trail">
            <app-achievements
                [mode]="'trail'"
                (changeAchievementEvent)="changeAchievement($event)"
                (emptyAchievementEvent)="emptyAchievement($event)">
            </app-achievements>
        </div>

        <p class="body2"><mat-checkbox (click)="changeFromCheckbox('ultra')" color="primary" formControlName="ultra">{{ 'registration.stepThree.question8.ultra' | translate}}</mat-checkbox></p>
        <div *ngIf="backgroundForm.value.ultra">
            <app-achievements
                [mode]="'ultra'"
                (changeAchievementEvent)="changeAchievement($event)"
                (emptyAchievementEvent)="emptyAchievement($event)">
            </app-achievements>
        </div>

    </mat-card>

    <mat-card class="cardCenter2">
        <p class="headline5NoCenter">{{ 'registration.stepThree.objetives.title' | translate}}</p>
        <p class="subtitle3">{{ 'registration.stepThree.objetives.question' | translate}}</p>
        <mat-radio-group color="primary" class="radioGroupColumn" formControlName="objetives" required>
            <mat-radio-button value="yes" (click)="changeObjetives(true)">{{'registration.stepThree.objetives.answer1' | translate}}</mat-radio-button>
            <div *ngIf="showObjetives">
                <app-objetives
                    *ngIf="!objetivesEmpty"
                    (emptyEvent)="emptyObjetives($event)">
                </app-objetives>
            </div>
            <mat-radio-button
                [checked]="objetivesEmpty" 
                value="no" 
                (click)="changeObjetives(false)">
                {{'registration.stepThree.objetives.answer2' | translate}}
            </mat-radio-button>
        </mat-radio-group>

    </mat-card>
</form>

<div *ngIf="!isMobile" class="cardCenter3">
    <div class="buttonInsideCard">
        <app-buttons [enablePrevious]="true" [background]="backgroundForm.value" [disabled]="!backgroundForm.valid || !objetivesValid || !rutaValid || !pistaValid || !ultraValid || !trailValid" ></app-buttons>
    </div>
</div>

<app-buttons *ngIf="isMobile" [enablePrevious]="true" [background]="backgroundForm.value" [disabled]="!backgroundForm.valid || !objetivesValid || !rutaValid || !pistaValid || !ultraValid || !trailValid" ></app-buttons>